import { forwardRef } from 'react';

import * as Styled from './Carousel.styles';

const CarouselContainer = forwardRef(({ className, offset, ...props }, ref) => {
  return (
    <Styled.Container
      ref={ref}
      className={className}
      $offset={offset}
      {...props}
    />
  );
});

CarouselContainer.displayName = 'CarouselContainer';

export default CarouselContainer;
